module.exports = __webpack_public_path__ + "static/media/archives.bd43231c.svg";